import { render, staticRenderFns } from "./ImageSwiper.vue?vue&type=template&id=3ed48bb1&scoped=true"
import script from "./ImageSwiper.vue?vue&type=script&lang=ts"
export * from "./ImageSwiper.vue?vue&type=script&lang=ts"
import style0 from "./ImageSwiper.vue?vue&type=style&index=0&id=3ed48bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed48bb1",
  null
  
)

export default component.exports